import type { ReleaseStatus } from '@chukua/common';

/** Display labels for `RELEASE_STATUSES` — the container details form's Release status select. */
export const RELEASE_STATUS_LABELS: Record<ReleaseStatus, string> = {
  pending: 'Pending',
  received: 'Received',
  verified: 'Verified',
};
